import React, { useEffect, useState } from "react";
import { Table, } from "antd";
import styles from "./WebsiteQueries.module.css";
import { Modal, TextComponent } from "../../components";
import { PagesMiddleware } from "../../Store/Middlewares/PagesMiddleware";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import Pagination from "../../components/Pagination/Pagination";


const WebsiteQueries = () => {

  const SUPPORT_QUERIES = useSelector(state => state.PagesReducer.webQueries);
  const SUPPORT_QUERIES_PAGINATION = useSelector(state => state.PagesReducer.webQueriesPagination);

  const [currentPage, setCurrentPage] = useState(1)
  const [pageLimit, setPageLimit] = useState(12);
  const dispatch = useDispatch()

  useEffect(() => {
    getData()
  }, []);

  const getData = (arg) => {
    const data = {
      limit: pageLimit,
      page: 1,
    };
    dispatch(PagesMiddleware.getWebQueries(arg || data))
      .then((res) => { })
      .catch((err) => { console.log("error", err) });
  }

  const columns = [
     {
      title: "S.No",
      dataIndex: "id",
      key: "S.No",
      render: (text, record, index) => {
        return (
          <TextComponent
            text={index + 1}
            style={{ color: "black" }}
          />
        );
      },
    },
    {
      title: "User Name",
      dataIndex: "lastName",
      key: "User Name",
      render: (text, record) => (
        <TextComponent
          text={record?.firstName + " " + record?.lastName}
          style={{ color: "black" }}
        />
      ),
    },
    {
      title: "Email",
      dataIndex: "email",
      key: "Email",
    },
     {
      title: "Phone no.",
      dataIndex: "phone",
      key: "Phone no.",
    },
    {
      title: "Query",
      dataIndex: "message",
      key: "Query",
      render: (text) => (
        <TextComponent
          text={text}
          style={{ color: "black" , maxWidth: "110px",   }}
        />
      ),
    },
    {
      title: "Submitted On",
      dataIndex: "createdAt",
      key: "Submitted On",
      render: (text) => (
        <TextComponent
          text={moment(text).format("MMM, DD, YYYY")}
          style={{ color: "black" }}
        />
      ),
    },
     
  ];

  return (
    <div className={styles.mainCont}>

      <div className={styles.HeadingDiv}>
        <TextComponent
          className={styles.Heading}
          text={"Website Queries"}
        />
      </div>


      <div className={styles.TableDiv}>
        <Table
          scroll={{ x: true }}
          columns={columns}
          dataSource={SUPPORT_QUERIES}
          pagination={false}
          style={{
            boxShadow: 'rgba(0, 0, 0, 0.15) 0px 5px 15px 0px'
          }}
        />

        {

          (SUPPORT_QUERIES_PAGINATION?.totalPages > 1) &&
          <Pagination
            currentPage={currentPage}
            totalPages={SUPPORT_QUERIES_PAGINATION?.totalPages}
            nextButton={(e) => {
              getData({
                limit: pageLimit,
                page: currentPage + 1,
              });
              setCurrentPage(currentPage + 1);
            }}
            previousButton={(e) => {
              getData({
                limit: pageLimit,
                page: currentPage - 1,
              });
              setCurrentPage(currentPage - 1);
            }}
          />
        }

      </div>
    </div>
  );
};

export default WebsiteQueries;
